export default {
  "fr": {
    "company_shareholding_type_id_list_100": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise publique"])},
    "company_shareholding_type_id_list_101": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise familiale"])},
    "company_shareholding_type_id_list_136": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Franchises et assimilé"])},
    "company_shareholding_type_id_list_141": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filiale d'un groupe"])},
    "company_shareholding_type_id_list_173": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises appartenant à un fonds d\"investissement"])}
  },
  "en": {
    
  }
}